export default {
  id: "page1",
  header: "Dane osobowe",
  questions: [
    {
      id: "respondent_imie",
      number: "1",
      label: "Imię",
      type: "text",
      required: true,
      validations: { minLength: 2, maxLength: 50 }
    },
    {
      id: "respondent_nazwisko",
      number: "2",
      label: "Nazwisko",
      type: "text",
      required: true,
      validations: { minLength: 2, maxLength: 100 }
    },
    {
      id: "respondent_plec",
      number: "3",
      label: "Płeć",
      type: "radio",
      required: true,
      options: [
        { value: "0", name: "Kobieta" },
        { value: "1", name: "Mężczyzna" }
      ]
    },
    // {
    //   id: "respondent_adres",
    //   number: "4",
    //   label: "Adres domowy (ulica, nr domu/mieszkania)",
    //   type: "text",
    //   required: true,
    //   validations: { minLength: 5, maxLength: 255 }
    // },
    {
      type: "select",
      label: "Miejscowość",
      id: "respondent_miasto",
      required: true,
      options: [
        { value: "", name: "" },
        { value: "Gdańsk", name: "Gdańsk" },
        { value: "Gdynia", name: "Gdynia" },
        { value: "Sopot", name: "Sopot" },
        { value: "other", name: "Inna" }
      ],
      number: "5"
    },
    {
      label: "Inna miejscowość - napisz jaka",
      id: "respondent_miasto_inne",
      required: true,
      show: [["respondent_miasto", "==='other'"]],
      columns: true,
      validations: { minLength: 5, maxLength: 50 },
      labelStrong: true,
      number: "5a"
    },
    // {
    //   id: "respondent_telefonDom",
    //   number: "6",
    //   label: "Telefon domowy",
    //   type: "text",
    //   required: false,
    //   validations: {
    //     isPhone: true,
    //     isPhoneMsg:
    //       "Prosimy upewnić się, że wpisano właściwy numer telefonu. Proszę podać 9 cyfr (razem z numerem kierunkowym).",
    //     requireIfNotExists: {
    //       field: "respondent_telefonKom",
    //       message: "Proszę podać przynajmniej jeden numer telefonu"
    //     }
    //   }
    // },
    {
      id: "respondent_telefonKom",
      number: "7",
      label: "Telefon komórkowy",
      type: "text",
      required: true,
      validations: {
        isPhone: true,
        isPhoneMsg:
          "Prosimy upewnić się, że wpisano właściwy numer telefonu. Proszę podać 9 cyfr numeru (np: 500100100).",
        // requireIfNotExists: {
        //   field: "respondent_telefonDom",
        //   message: "Proszę podać przynajmniej jeden numer telefonu"
        // }
      }
    },
    {
      id: "respondent_email",
      number: "8",
      label: "e-mail: (odbierany regularnie / do bieżących kontaktów)",
      type: "text",
      required: true,
      validations: { isEmail: true, maxLength: 255 }
    },
    {
      id: "respondent_rokUrodzenia",
      number: "9",
      label: "Rok urodzenia",
      type: "text",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 100,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia.",
        lowerThan: new Date().getFullYear() - 17,
        lowerThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek jest mniejszy niż 18 lat"
      }
    },
    // {
    //   id: "respondent_osobyGospodarstwo",
    //   number: "10",
    //   label: "Liczba osób w gospodarstwie domowym: <br>(łącznie z Panem(ią))",
    //   type: "text",
    //   required: true,
    //   initValue: "1",
    //   validations: {
    //     isNumeric: true,
    //     higherThan: 0,
    //     lowerThan: 99
    //   }
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page1.js